// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__15-ML","empty":"ModalGraph_empty__1hCbZ"};